//Locations slider swiper
if ($('.promotions_slider').length > 0) {
    const swiper = new Swiper('.promotions_slider', {
        // Optional parameters
        direction: 'horizontal',
        slidesPerView: 3,
        spaceBetween: 20,
        navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
          },
        // Responsive breakpoints
        breakpoints: {
            280: {
                slidesPerView: 1,
            },
            320: {
                slidesPerView: 1,
            },
            991: {
                slidesPerView: 2,
            },
            1400: {
                slidesPerView: 3,
            },
        },
    });
}
